// ============================================================================
// Entry point. Wires the portable core to the presentation layer and boots the
// app: theme first (before any render), then auth state, then the shell.
// ============================================================================

import './ui/styles/tokens.css';
import './ui/styles/app.css';

import { initTheme } from './ui/theme.js';
import { startApp } from './ui/app.js';

initTheme();
startApp(document.getElementById('app'));
